import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'shortText',
})

/**
 * This pipe is used to transform
 * the long text into short text.
 * it will take the numeric value as limit and then add (...) after the text
 *
 * Example of usage:
 * <p> {{ 'Hello world' | shortText: 5}} </p>"
 * Result Hello...
 */
export class LongtoShortTextPipe implements PipeTransform {
  transform(value: string, limit: number, showDots: boolean = false): string {
    return value.length > limit ? (showDots ? value.substring(0, limit) + '...' : value.substring(0, limit)) : value;
  }
}
